// extracted by mini-css-extract-plugin
export default {"filterBarContainer":"FilterBar_filterBarContainer__CRJXO","resultsText":"FilterBar_resultsText__q4TVj"};